module.exports = __webpack_public_path__ + "static/media/viper.5e445936.png";